import type { PrimaryNavLocale } from '../primary-nav-links';

const NUMBER_FORMAT_LOCALE_TAG: Record<PrimaryNavLocale, string> = {
  en: 'en-GB',
  fi: 'fi-FI',
  sv: 'sv-SE',
};

/** U+202F NARROW NO-BREAK SPACE: what some JS engines emit as the fi-FI/sv-SE thousands separator. */
const NARROW_NO_BREAK_SPACE = ' ';
/** U+00A0 NO-BREAK SPACE: normalised target, matching how the rest of the app formats thousands. */
const NO_BREAK_SPACE = ' ';

/**
 * Formats a navbar index-strip figure per locale: en-GB gives a comma thousands separator,
 * fi-FI/sv-SE give a space. Some JS engines render that fi/sv space as a narrow no-break space
 * rather than a regular no-break space; normalised here so the figure renders consistently
 * across browsers instead of looking like two numbers glued together.
 */
export function formatNavFigure(value: number, locale: PrimaryNavLocale): string {
  const formatted = new Intl.NumberFormat(NUMBER_FORMAT_LOCALE_TAG[locale]).format(value);
  return formatted.split(NARROW_NO_BREAK_SPACE).join(NO_BREAK_SPACE);
}
